import {View} from 'MWC';
import tpl from '../templates/CustomDropdown.jsx';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            active: false
        };

        this.toggleActive = this.toggleActive.bind(this);
    }

    toggleActive() {
        this.setState(prevState => ({
            active: !prevState.active
        }));
    }
}
